const url= process.env.REACT_APP_LAUNCHADMINCLIENT

export const Configs = {
    url
}